<template>
  <div>
    <el-row>
      <el-col>
        <el-form :model="searchForm" ref="searchForm" :inline="true" >
          <el-form-item label="客户：">
            <label slot="label">客&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;户：</label>
            <el-select size="medium" filterable v-model="searchForm.TC_COMPANY" placeholder="请选择" style="margin-right:60px;"
              :clearable="true">
              <el-option v-for="item in companys" :key="item.ID" :label="item.AB_NAME" :value="item.ID"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="项目点：">
            <label slot="label">项&nbsp;目&nbsp;&nbsp;点：</label>
            <el-select size="medium" filterable v-model="searchForm.project" style="width:80%;margin-right:60px;" :clearable="true">
              <el-option v-for="item in allProjects" :key="item.PROJECT_ID" :label="item.PROJECT_NAME"
                :value="item.PROJECT_ID"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="日期范围：">
            <el-date-picker size="medium" v-model="searchForm.DAY_INTERVAL" type="daterange" align="right" unlink-panels
              range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions"
              value-format="yyyy-MM-dd" :clearable="false"></el-date-picker>
          </el-form-item>
          <el-form-item label="订单状态：">
            <el-select size="medium" filterable v-model="searchForm.status" style="width:80%;margin-right:60px;" :clearable="true">
              <el-option v-for="item in statusList" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button size="medium" type="primary" @click="doQueryTable()" :loading="loadSearch">筛选</el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
    <el-row>
      <el-col>
        <el-table :data="tableData" border stripe style="width: 100%;margin-top:20px">
          <!-- @selection-change="handleSelectionChange" show-summary -->
          <!-- <el-table-column type="selection" width="50" label="序号"></el-table-column> -->
          <el-table-column prop="SEND_DAY" label="送货日期" min-width="135"></el-table-column>
          <el-table-column prop="TC_NAME" label="客户" min-width="90"></el-table-column>
          <el-table-column prop="PROJECT_NAME" label="项目点" min-width="150"></el-table-column>
          <el-table-column prop="DK_NAME" label="档口" min-width="150"></el-table-column>
          <el-table-column prop="PRODUCT_CODE" label="产品编码" min-width="150"></el-table-column>
          <el-table-column prop="PRODUCT_NAME" label="名称" min-width="150"></el-table-column>
          <el-table-column prop="TYPE_UNIT" label="单位" min-width="150"></el-table-column>
          <el-table-column prop="REAL_PRICE" label="单价" min-width="150"></el-table-column>
          <el-table-column prop="COST_PRICE" label="成本价" min-width="150"></el-table-column>
          <el-table-column prop="AVG_REAL_PRICE_IN7DAYS" label="近七天平均销售价" min-width="150"></el-table-column>
          <el-table-column prop="LAST_REAL_PRICE" label="上次销售价" min-width="150"></el-table-column>
          <el-table-column prop="LAST_SALE_TIME" label="上次销售时间" min-width="150"></el-table-column>
          <el-table-column prop="PROFIT_PRICE" label="利润额" min-width="150"></el-table-column>
          <el-table-column prop="PROFIT_RATE" label="利润率" min-width="150"></el-table-column>
          <el-table-column prop="PRODUCT_COUNT" label="订购量" min-width="150"></el-table-column>
          <el-table-column prop="REAL_COUNT" label="实收量" min-width="150"></el-table-column>
          <el-table-column prop="REAL_TOTAL_FEE" label="实收总金额" min-width="150"></el-table-column>
          <el-table-column fixed="right" label="操作" width="150">
            <template slot-scope="scope">
              <el-button type="text" size="small" icon="el-icon-view" @click="modifyPrice(scope.row)">修改价格</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <!-- 修改价格 -->
    <el-dialog :visible.sync="editFormDialog" title="修改价格" width="400px" center>
      <el-form ref="editForm" v-model="editForm">
        <el-form-item label="产品编码：" :label-width="formLabelWidth">
          <span>{{ this.editForm.PRODUCT_CODE }}</span>
        </el-form-item>
        <el-form-item label="产品名称：" :label-width="formLabelWidth">
          <span>{{ this.editForm.PRODUCT_NAME }}</span>
        </el-form-item>
        <el-form-item label="单位：" :label-width="formLabelWidth">
          <label slot="label">单&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;位：</label>
          <span>{{ this.editForm.TYPE_UNIT }}</span>
        </el-form-item>
        <el-form-item label="单价：" :label-width="formLabelWidth">
          <label slot="label">单&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;价：</label>
          <el-input v-model="editForm.REAL_PRICE" oninput="value=value.replace(/[^0-9.]/g,'')"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" style="text-align: center;">
        <el-button class="operate-btn" @click="editFormDialog = false">取消</el-button>
        <el-button class="operate-btn" @click="submitModify">确认</el-button>
      </div>
    </el-dialog>
    <el-row>
      <el-col :span="24" style="text-align: right">
        <el-pagination @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-size="pageSize"
          layout="total,prev, pager, next, jumper" :total="totalCount"></el-pagination>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import { getEnteyCusFun, haveXMDFun, updateOrderFun } from 'api/sellOrder';
import http from '@/assets/common/http';
import util from '@/assets/common/util';
import validation from '@/assets/common/validation';

export default {
  data() {
    return {
      loadSearch: false,
      editFormDialog: false,
      editForm: {},
      currentPage: 1,
      totalCount: 0,
      pageSize: 10,
      companys: [],
      pickerOptions: {
        shortcuts: [
          {
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            },
          },
        ],
      },
      tableData: [],
      searchForm: { DAY_INTERVAL: [util.getNowDate(), util.getNowDate()] },
      checkedArray: [],
      allProjects: [],
      statusList: [{ value: 1, label: '待送订单' }, { value: 4, label: '待确认订单' }],
      formLabelWidth: '120px',
    };
  },
  created() {
    // 这里用来在设置中设置页面展示条目，文件在setting的generalSettings中，由前端控制条目，存储于localStorage中，key为SMP_PAGE_COUNT
    this.pageSize = Number(localStorage.getItem('SMP_PAGE_COUNT')) ? Number(localStorage.getItem('SMP_PAGE_COUNT')) : 10;

    if (this.SALES_PRICE_REVIEW_CONDITION.CONDITION) {
      this.searchForm = this.SALES_PRICE_REVIEW_CONDITION.CONDITION;
      this.currentPage = this.SALES_PRICE_REVIEW_CONDITION.CURRENT_PAGE;
    } else {
      this.currentPage = 1;
    }
    this.queryCustomer();
    this.queryTable();
    this.queryAllProject();
  },
  computed: {
    SALES_PRICE_REVIEW_CONDITION() {
      return this.$store.state.SALES_PRICE_REVIEW_CONDITION;
    },
  },
  methods: {
    // 选择客户
    queryCustomer() {
      getEnteyCusFun()
        .then((result) => {
          if (result.length !== 0) {
            this.companys = util.listRemoveDuplicates(result);
          } else {
            this.companys = [];
          }
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
    },
    queryAllProject() {
      const paramsProject = {};
      haveXMDFun(paramsProject)
        .then((result) => {
          if (result[0]) {
            this.allProjects = result[0].project;
          } else {
            this.allProjects = [];
          }
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
    },
    doQueryTable() {
      this.currentPage = 1;
      this.queryTable();
    },
    // 进入页面拉取数据
    queryTable() {
      const params = {
        SERVICE_ID: '10009',
        OTYPE: 62,
        SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
        START_DAY: this.searchForm.DAY_INTERVAL[0],
        END_DAY: this.searchForm.DAY_INTERVAL[1],
        PAGESIZE: this.pageSize,
        PAGEINDEX: this.currentPage - 1,
      };
      if (this.searchForm.TC_COMPANY) {
        params.TC_ID = this.searchForm.TC_COMPANY;
      }
      if (this.searchForm.project) {
        params.PROJECT_ID = this.searchForm.project;
      }
      if (this.searchForm.status) {
        params.STATUS = this.searchForm.status;
      }
      this.loadSearch = true;
      http.post(params)
        .then((result) => {
          this.tableData = result[0].list;
          this.totalCount = result[0].TOTAL_COUNT;
          this.$store.dispatch('SET_SALES_PRICE_REVIEW_CONDITION', {
            CONDITION: this.searchForm,
            DATA: this.tableData,
            TOTAL_COUNT: this.totalCount,
            CURRENT_PAGE: this.currentPage,
          });
          this.loadSearch = false;
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
          this.loadSearch = false;
        });
    },
    // 修改价格
    modifyPrice(row) {
      this.editFormDialog = true;
      this.editForm = { ...row };
    },
    // ------------------------------修改订单详情
    submitModify() {
      if (!validation.价格正数0验证(this.editForm.REAL_PRICE)) {
        this.$message.show({ text: '请输入正数单价', type: 'warning' });
        return false;
      }
      const updateParams = {
        PRODUCT_CODE: Number(this.editForm.PRODUCT_CODE),
        ORDER_DETAIL_ID: Number(this.editForm.DETAIL_ID),
        PRICE: Number(this.editForm.REAL_PRICE),
      };
      updateOrderFun(updateParams)
        .then((result) => {
          this.$message.show({ text: '修改成功', type: 'success' });
          this.editFormDialog = false;
          this.queryTable();
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
    },
    handleCurrentChange(e) {
      this.currentPage = e;
      this.queryTable();
    },
    handleSelectionChange(val) {
      this.checkedArray = val.map((item) => ({ ORDER_ID: item.ORDER_ID }));
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/sellOrderManage/salesPriceReview.vue